import { useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import api from "@/utils/api";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

const inp = "h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#159DFF]";

export default function ChangePassword() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 12) return toast.error("New password must be at least 12 characters");
    if (nw !== cf) return toast.error("New password and confirmation do not match");
    setBusy(true);
    try {
      await api.post("/v2/account/change-password", { current_password: cur, new_password: nw, confirm_password: cf });
      toast.success("Password changed. Save it in your vault.");
      setCur(""); setNw(""); setCf("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <DashboardLayout>
      <div className="max-w-md mx-auto py-8 px-4">
        <div className="flex items-center gap-2 mb-1">
          <KeyRound className="w-5 h-5 text-[#159DFF]" />
          <h1 className="text-xl font-semibold text-slate-900">Change password</h1>
        </div>
        <p className="text-sm text-slate-500 mb-6">Use at least 12 characters. Store it in your password vault.</p>
        <form onSubmit={submit} className="space-y-4 bg-white border border-slate-200 rounded-lg p-5">
          <div>
            <label className="text-sm font-medium text-slate-700">Current password</label>
            <input type="password" autoComplete="current-password" className={inp} value={cur} onChange={(e) => setCur(e.target.value)} required />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">New password</label>
            <input type="password" autoComplete="new-password" className={inp} value={nw} onChange={(e) => setNw(e.target.value)} required minLength={12} />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Repeat new password</label>
            <input type="password" autoComplete="new-password" className={inp} value={cf} onChange={(e) => setCf(e.target.value)} required />
          </div>
          <Button type="submit" disabled={busy} className="w-full">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Change password"}
          </Button>
        </form>
      </div>
    </DashboardLayout>
  );
}
